import { NavCloseIcon, OutlinedInfoIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface InvoiceTaxEncouragedPopupProps {
  onClose: VoidFn;
  onAddTax: VoidFn;
  onProceedAnyway: VoidFn;
  isEdit?: boolean;
  taxEncouragedThreshold?: string;
  isLoading: boolean;
}

const InvoiceTaxEncouragedPopup: FC<InvoiceTaxEncouragedPopupProps> = ({
  onClose,
  onAddTax,
  onProceedAnyway,
  isEdit = false,
  taxEncouragedThreshold,
  isLoading = false
}) => {
  const handleAddTax = () => {
    onClose();
    onAddTax();
  };

  const handleProceedAnyway = () => {
    onClose();
    onProceedAnyway();
  };

  return (
    <CustomModal open={true} width="md:w-[400px]">
      <div className="relative">
        <div
          className="absolute right-2.5 top-2.5 cursor-pointer"
          onClick={onClose}
          role="button"
          tabIndex={0}
          aria-label="Close tax encouraged popup">
          <NavCloseIcon />
        </div>
        <div className="flex flex-col items-center gap-3.5 px-8 pt-4">
          <div className="flex h-[70px] w-[70px] shrink-0 items-center justify-center rounded-full bg-[#EAF1FF]">
            <OutlinedInfoIcon className="h-8 w-8 text-secondary" />
          </div>

          <div className="text-center text-17px font-semibold text-primaryText">Tax recommendation</div>

          <div className="text-center text-sbase text-primaryText">
            Tax is typically included on invoices of this size. Would you like to add tax before sending?
          </div>
        </div>
        <div className="m-4 flex flex-col gap-3">
          <CustomButton
            id="tax-encouraged-create-anyway-btn"
            onClick={handleProceedAnyway}
            className="h-12 w-full"
            isLoading={isLoading}>
            Continue without tax
          </CustomButton>
          <CustomButton
            id="tax-encouraged-add-tax-btn"
            onClick={handleAddTax}
            type={ButtonType.SECONDARY}
            className="h-12 w-full">
            Add tax
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default InvoiceTaxEncouragedPopup;
